import { useSelectContext } from './context'
import { OptionData, OptionApi } from './types'

export function useOption(option: OptionData): OptionApi {
  const register = useSelectContext()
  return register(option)
}
